// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10SLm","colBig":"styles_colBig__2VyqX","colSmall":"styles_colSmall__jYdic","shopifyNameWrapper":"styles_shopifyNameWrapper__7mnbT"};